export default {
	SupplierAcceptTaxAuthorities(state) {
		return state.SupplierAcceptTaxAuthorities;
	},
	SupplierAcceptTaxAuthority(state) {
		return state.SupplierAcceptTaxAuthority;
	},
	Total(state) {
		return state.Total;
	},
	IsLoadingData(state) {
		return state.IsLoadingData;
	}
};
